import React, { Component, useEffect, useState } from "react";
import ComponentForgotPasswordMobile from "./ComponentForgotPasswordMobile";
import ComponentForgotPasswordWeb from "./ComponentForgotPasswordWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentForgotPassword = () => {
  const gaEventTracker = useAnalyticsEventTracker("ForgotPassword");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Forgot Password",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentForgotPasswordWeb></ComponentForgotPasswordWeb>
      </BrowserView>
      <MobileView>
        <ComponentForgotPasswordMobile></ComponentForgotPasswordMobile>
      </MobileView>
    </>
  );
};

export default ComponentForgotPassword;
